import { Injectable } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { GbBaseDialogService } from 'libs/shared/utils/dialogs/src'

@Injectable({
  providedIn: 'root',
})
export class GbDashboardDialogService extends GbBaseDialogService {
  constructor(protected matDialog: MatDialog) {
    super(matDialog)
  }
}
